document.addEventListener("DOMContentLoaded", function () {
  // ─── FAQ Accordion ────────────────────────────────────────────────────────
  const faq_items = document.querySelectorAll(".accordion__container .accordion__button");

  function toggleAccordion() {
    const faq_itemToggle = this.getAttribute("aria-expanded");
    const faqContent = this.nextElementSibling;

    this.parentElement.classList.add("active");

    Array.from(this.parentElement.parentElement.children).forEach((sibling) => {
      if (sibling !== this.parentElement) {
        sibling.classList.remove("active");
        const siblingContent = sibling.querySelector(".accordion_content");
        if (siblingContent) siblingContent.style.maxHeight = 0;
      }
    });

    for (let i = 0; i < faq_items.length; i++) {
      faq_items[i].setAttribute("aria-expanded", "false");
    }

    if (faq_itemToggle === "false") {
      this.setAttribute("aria-expanded", "true");
      if (faqContent) faqContent.style.maxHeight = faqContent.scrollHeight + "px";
    } else {
      if (faqContent) faqContent.style.maxHeight = 0;
    }
  }

  faq_items.forEach((item) => item.addEventListener("click", toggleAccordion));

  // ─── Image Cards ──────────────────────────────────────────────────────────
  const ImageCardItems = document.querySelectorAll(".image_card_item");
  ImageCardItems.forEach((item) => {
    item.addEventListener("click", () => {
      ImageCardItems.forEach((sibling) => {
        if (sibling !== item) sibling.classList.remove("active");
      });
      item.classList.toggle("active");
    });
  });

  // ─── Hotspot buttons ──────────────────────────────────────────────────────
  $(document).on("click", ".hotspot_media .hotspot_btn", function () {
    var activeContentId = $(this).data("content");
    $(".hotspot_media .hotspot_btn").removeClass("isActive");
    $(this).addClass("isActive");
    $(".hotspot_content").removeClass("active");
    $("#" + activeContentId).addClass("active");
  });

  $(document).on("click", ".hotspot_btn", function () {
    var activeContentId = $(this).data("content");
    var id = $(this).attr("data");
    $(".hotspot_btn").removeClass("isActive");
    $(`.hotspot_btn[data="${id}"]`).addClass("isActive");
    $(".hotspot_content").removeClass("active");
    $("#" + activeContentId).addClass("active");
  });

  // ─── What's Included Set (pdp-whats-included.liquid) ──────────────────────
  // Swiper carousel voor set-items met detail view
  if (typeof Swiper !== "undefined") {
    document.querySelectorAll(".wis-acc").forEach(function (container) {
      if (container.__wisInitialized) return;

      const outer = container.querySelector(".wis-swiper-outer");
      const swiperEl = container.querySelector(".wis-swiper");
      if (!outer || !swiperEl) return;

      container.__wisInitialized = true;

      const slides = container.querySelectorAll(".wis-slide");
      const infos = container.querySelectorAll(".wis-info");
      const prevBtns = container.querySelectorAll(".wis-btn-prev");
      const nextBtns = container.querySelectorAll(".wis-btn-next");
      const totalItems = slides.length;
      if (totalItems === 0) return;

      let activeIndex = 0;

      const wisSwiper = new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 8,
        breakpoints: {
          0: { slidesPerView: 3 },
          750: { slidesPerView: 4 },
        },
      });

      function updateNavState() {
        prevBtns.forEach((b) => b.classList.toggle("wis-disabled", activeIndex === 0));
        nextBtns.forEach((b) => b.classList.toggle("wis-disabled", activeIndex === totalItems - 1));
      }

      function setActive(index) {
        if (index < 0 || index >= totalItems) return;
        activeIndex = index;
        slides.forEach((el) => el.classList.toggle("wis-active", parseInt(el.dataset.wisIndex) === index));
        infos.forEach((el) => el.classList.toggle("wis-active", parseInt(el.dataset.wisIndex) === index));
        wisSwiper.slideTo(index);
        updateNavState();
      }

      updateNavState();
      prevBtns.forEach((b) =>
        b.addEventListener("click", function (e) {
          e.stopPropagation();
          setActive(activeIndex - 1);
        })
      );
      nextBtns.forEach((b) =>
        b.addEventListener("click", function (e) {
          e.stopPropagation();
          setActive(activeIndex + 1);
        })
      );
      slides.forEach((s) =>
        s.addEventListener("click", function () {
          setActive(parseInt(s.dataset.wisIndex));
        })
      );

      // ─── Swipe support op .wis-detail ──────────────────────────────────────
      const wisDetail = container.querySelector(".wis-detail");
      if (wisDetail) {
        let touchStartX = 0;
        let touchStartY = 0;
        let touchStartTime = 0;

        wisDetail.addEventListener(
          "touchstart",
          function (e) {
            touchStartX = e.touches[0].clientX;
            touchStartY = e.touches[0].clientY;
            touchStartTime = Date.now();
          },
          { passive: true }
        );

        wisDetail.addEventListener(
          "touchend",
          function (e) {
            const endX = e.changedTouches[0].clientX;
            const endY = e.changedTouches[0].clientY;
            const deltaX = endX - touchStartX;
            const deltaY = Math.abs(endY - touchStartY);
            const elapsed = Date.now() - touchStartTime;

            if (elapsed < 1000 && Math.abs(deltaX) > 40 && deltaY < 80) {
              if (deltaX < 0) {
                setActive(activeIndex + 1);
              } else {
                setActive(activeIndex - 1);
              }
            }
          },
          { passive: true }
        );
      }
    });
  }

  // ─── Main product video popup + Review modal ──────────────────────────────
  const popupBtn = document.querySelector(".popup_btn");
  const modal = document.querySelector(".ctm_product_modal");
  const overlay = document.querySelector(".ctm_product_modal_overlay");
  const closeBtn = document.querySelector(".ctm_product_modal .ctm_close_modal");
  const productVideo = document.querySelector(".ctm_product_modal video");

  // ─── Review modal elementen (nodig voor closeReviewModal scope) ───────────
  const reviewModal = document.querySelector(".ctm_review_video_modal");
  const reviewModalInner = document.querySelector(".ctm_review_video_modal .ctm_modal-content");
  const ReviewCloseBtn = document.querySelector(".ctm_review_video_modal .ctm_close_modal");

  let modalSwiper = null;

  function buildModalSwiper() {
    if (!reviewModalInner || document.querySelector(".ctm_review_video_modal .swiper")) return;

    const slides = document.querySelectorAll(".video_review_slider .swiper-slide .review_video_main");
    if (!slides.length) return;

    const videoData = [];
    slides.forEach((slide) => {
      // Bron kan op meerdere plekken staan, in volgorde van prioriteit:
      //   1. .review-video-poster[data-review-video-src]   (nieuwe click-to-play markup)
      //   2. video[data-review-video-src]                  (oude lazy markup, fallback)
      //   3. video > source[src]                           (oudste markup, fallback)
      const posterEl = slide.querySelector(".review-video-poster");
      const videoEl = slide.querySelector("video");
      const src = posterEl?.getAttribute("data-review-video-src")
                  || videoEl?.getAttribute("data-review-video-src")
                  || videoEl?.querySelector("source")?.getAttribute("src")
                  || "";
      const title = slide.querySelector(".review__title")?.textContent || "";
      videoData.push({ src, title });
    });

    let slidesHTML = videoData
      .map(
        ({ src, title }) => `
      <div class="swiper-slide">
        <div class="ctm_modal_sidebar">
          <button class="ctm_close_inline" type="button" aria-label="Close video">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 10.586L4.70718 3.29297L3.29297 4.70718L10.586 12.0002L3.29297 19.2933L4.70718 20.7075L12.0002 13.4145L19.2933 20.7075L20.7075 19.2933L13.4145 12.0002L20.7075 4.70723L19.2933 3.29302L12.0002 10.586Z" fill="white"></path>
            </svg>
          </button>
          <button class="ctm_playpause_btn" type="button" aria-label="Play/Pause">
            <svg class="ctm_icon_play" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" fill="white">
              <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
            </svg>
            <svg class="ctm_icon_pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="18" height="18" fill="white" style="display:none">
              <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
            </svg>
          </button>
          <button class="ctm_mute_btn" type="button" aria-label="Mute/Unmute">
            <svg class="ctm_icon_unmuted" viewBox="0 0 24 24" width="18" height="18" fill="white">
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm13.517 4.134l-1.416-1.416A8.978 8.978 0 0 0 21 12a8.982 8.982 0 0 0-3.304-6.968l1.42-1.42A10.976 10.976 0 0 1 23 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.993 3.993 0 0 0 16 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0 1 18 12c0 1.842-.83 3.49-2.137 4.591z"/>
            </svg>
            <svg class="ctm_icon_muted" viewBox="0 0 24 24" width="18" height="18" fill="white" style="display:none">
              <path fill="none" d="M0 0h24v24H0z"></path>
              <path d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z"/>
            </svg>
          </button>
        </div>
        <div class="ctm_modal_slide_inner">
          <div class="ctm_progress_bar"><div class="ctm_progress_fill"></div></div>
          <video class="ctm_review-modal-video" playsinline webkit-playsinline preload="metadata">
            <source src="${src}" type="video/mp4">
          </video>
          ${title ? `<p class="ctm_modal_slide_title">${title}</p>` : ""}
        </div>
      </div>
    `
      )
      .join("");

    reviewModalInner.innerHTML = `
      <button class="ctm_nav_btn ctm_nav_prev" type="button" aria-label="Previous slide">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path d="m8.5 12.8 5.7 5.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4.9-5 4.9-5c.4-.4.4-1 0-1.4-.2-.2-.4-.3-.7-.3-.3 0-.5.1-.7.3l-5.7 5.6c-.4.5-.4 1.1 0 1.6 0-.1 0-.1 0 0z" fill="black"></path>
        </svg>
      </button>
      <div class="swiper ctm_review_swiper">
        <div class="swiper-wrapper">${slidesHTML}</div>
      </div>
      <button class="ctm_nav_btn ctm_nav_next" type="button" aria-label="Next slide">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z" fill="black"></path>
        </svg>
      </button>
    `;
  }

  function updateNavBtns() {
    const prev = document.querySelector(".ctm_nav_prev");
    const next = document.querySelector(".ctm_nav_next");
    if (!prev || !next || !modalSwiper) return;
    prev.style.opacity = modalSwiper.isBeginning ? "0.3" : "1";
    next.style.opacity = modalSwiper.isEnd ? "0.3" : "1";
  }

  function pauseAllModalVideos() {
    document.querySelectorAll(".ctm_review_swiper video").forEach((v) => {
      v.pause();
      v.currentTime = 0;
    });
  }

  function playActiveModalVideo() {
    const active = document.querySelector(".ctm_review_swiper .swiper-slide-active video");
    if (active) active.play().catch(() => {});
  }

  function initModalSwiper(startIndex) {
    buildModalSwiper();

    if (modalSwiper) {
      modalSwiper.destroy(true, true);
      modalSwiper = null;
    }

    const prevBtn = document.querySelector(".ctm_nav_prev");
    const nextBtn = document.querySelector(".ctm_nav_next");

    if (prevBtn && nextBtn) {
      const newPrev = prevBtn.cloneNode(true);
      const newNext = nextBtn.cloneNode(true);
      prevBtn.parentNode.replaceChild(newPrev, prevBtn);
      nextBtn.parentNode.replaceChild(newNext, nextBtn);
    }

    modalSwiper = new Swiper(".ctm_review_swiper", {
      slidesPerView: 1,
      spaceBetween: 0,
      initialSlide: startIndex || 0,
      loop: false,
      on: {
        slideChange: function () {
          pauseAllModalVideos();
          setTimeout(playActiveModalVideo, 300);
          setTimeout(updateNavBtns, 50);
        },
      },
    });

    const navPrev = document.querySelector(".ctm_nav_prev");
    const navNext = document.querySelector(".ctm_nav_next");
    if (navPrev) {
      navPrev.addEventListener("click", () => {
        modalSwiper.slidePrev();
        setTimeout(updateNavBtns, 50);
      });
    }
    if (navNext) {
      navNext.addEventListener("click", () => {
        modalSwiper.slideNext();
        setTimeout(updateNavBtns, 50);
      });
    }

    updateNavBtns();
  }

  function openReviewModal(startIndex) {
    if (overlay) overlay.style.display = "block";
    if (reviewModal) reviewModal.classList.add("active");
    initModalSwiper(startIndex);
    setTimeout(playActiveModalVideo, 100);
  }

  function closeReviewModal() {
    if (overlay) overlay.style.display = "none";
    if (reviewModal) reviewModal.classList.remove("active");
    pauseAllModalVideos();
  }

  // ─── Product video modal setup ────────────────────────────────────────────
  if (productVideo && modal) {
    productVideo.removeAttribute("controls");
    productVideo.setAttribute("playsinline", "");

    if (!modal.querySelector(".ctm_modal_sidebar")) {
      const sidebar = document.createElement("div");
      sidebar.className = "ctm_modal_sidebar";
      sidebar.innerHTML = `
        <button class="ctm_product_close_btn" type="button" aria-label="Close video">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 10.586L4.70718 3.29297L3.29297 4.70718L10.586 12.0002L3.29297 19.2933L4.70718 20.7075L12.0002 13.4145L19.2933 20.7075L20.7075 19.2933L13.4145 12.0002L20.7075 4.70723L19.2933 3.29302L12.0002 10.586Z" fill="white"></path>
          </svg>
        </button>
        <button class="ctm_product_playpause_btn" type="button" aria-label="Play/Pause">
          <svg class="ctm_icon_play" viewBox="0 0 16 16" width="18" height="18" fill="white">
            <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"/>
          </svg>
          <svg class="ctm_icon_pause" viewBox="0 0 16 16" width="18" height="18" fill="white" style="display:none">
            <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"/>
          </svg>
        </button>
        <button class="ctm_product_mute_btn" type="button" aria-label="Mute/Unmute">
          <svg class="ctm_icon_unmuted" viewBox="0 0 24 24" width="18" height="18" fill="white">
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm13.517 4.134l-1.416-1.416A8.978 8.978 0 0 0 21 12a8.982 8.982 0 0 0-3.304-6.968l1.42-1.42A10.976 10.976 0 0 1 23 12c0 3.223-1.386 6.122-3.594 8.134zm-3.543-3.543l-1.422-1.422A3.993 3.993 0 0 0 16 12c0-1.43-.75-2.685-1.88-3.392l1.439-1.439A5.991 5.991 0 0 1 18 12c0 1.842-.83 3.49-2.137 4.591z"/>
          </svg>
          <svg class="ctm_icon_muted" viewBox="0 0 24 24" width="18" height="18" fill="white" style="display:none">
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M5.889 16H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3.889l5.294-4.332a.5.5 0 0 1 .817.387v15.89a.5.5 0 0 1-.817.387L5.89 16zm14.525-4l3.536 3.536-1.414 1.414L19 13.414l-3.536 3.536-1.414-1.414L17.586 12 14.05 8.464l1.414-1.414L19 10.586l3.536-3.536 1.414 1.414L20.414 12z"/>
          </svg>
        </button>
      `;
      modal.querySelector(".ctm_modal-content").appendChild(sidebar);

      const progressBar = document.createElement("div");
      progressBar.className = "ctm_progress_bar--bottom";
      progressBar.innerHTML = '<div class="ctm_progress_fill_bottom"></div>';
      modal.querySelector(".ctm_modal-content").appendChild(progressBar);

      progressBar.addEventListener("click", function (e) {
        if (!productVideo.duration) return;
        const rect = progressBar.getBoundingClientRect();
        const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
        productVideo.currentTime = ratio * productVideo.duration;
      });

      progressBar.addEventListener(
        "touchstart",
        function (e) {
          const touch = e.touches[0];
          const rect = progressBar.getBoundingClientRect();
          const ratio = Math.max(0, Math.min(1, (touch.clientX - rect.left) / rect.width));
          if (productVideo.duration) productVideo.currentTime = ratio * productVideo.duration;
        },
        { passive: true }
      );
    }

    function closeProductModal() {
      if (overlay) overlay.style.display = "none";
      modal.classList.remove("active");
      if (productVideo) {
        productVideo.pause();
        productVideo.currentTime = 0;
      }
      const fill = modal.querySelector(".ctm_progress_fill_bottom");
      if (fill) fill.style.width = "0%";
    }

    function openProductModal() {
      if (overlay) overlay.style.display = "block";
      modal.classList.add("active");
      if (productVideo) productVideo.play();
    }

    const productCloseButton = modal.querySelector(".ctm_product_close_btn");
    if (productCloseButton) productCloseButton.addEventListener("click", closeProductModal);

    const playPauseBtn = modal.querySelector(".ctm_product_playpause_btn");
    if (playPauseBtn) {
      playPauseBtn.addEventListener("click", () => {
        if (productVideo.paused) {
          productVideo.play();
        } else {
          productVideo.pause();
        }
      });
    }

    const muteBtn = modal.querySelector(".ctm_product_mute_btn");
    if (muteBtn) {
      muteBtn.addEventListener("click", () => {
        productVideo.muted = !productVideo.muted;
        muteBtn.querySelector(".ctm_icon_unmuted").style.display = productVideo.muted ? "none" : "block";
        muteBtn.querySelector(".ctm_icon_muted").style.display = productVideo.muted ? "block" : "none";
      });
    }

    productVideo.addEventListener("play", () => {
      const btn = modal.querySelector(".ctm_product_playpause_btn");
      if (!btn) return;
      btn.querySelector(".ctm_icon_play").style.display = "none";
      btn.querySelector(".ctm_icon_pause").style.display = "block";
    });

    productVideo.addEventListener("pause", () => {
      const btn = modal.querySelector(".ctm_product_playpause_btn");
      if (!btn) return;
      btn.querySelector(".ctm_icon_play").style.display = "block";
      btn.querySelector(".ctm_icon_pause").style.display = "none";
    });

    productVideo.addEventListener("timeupdate", function () {
      if (!this.duration) return;
      const fill = modal.querySelector(".ctm_progress_fill_bottom");
      if (fill) fill.style.width = (this.currentTime / this.duration) * 100 + "%";
    });

    if (popupBtn) popupBtn.addEventListener("click", openProductModal);
    if (closeBtn) closeBtn.addEventListener("click", closeProductModal);

    modal.addEventListener("click", function (e) {
      if (!e.target.closest(".ctm_modal-content")) closeProductModal();
    });

    if (overlay) {
      overlay.addEventListener("click", function (e) {
        e.stopPropagation();
        closeProductModal();
        closeReviewModal();
      });
    }
  }

  // ─── Review modal event handlers ──────────────────────────────────────────
  document.addEventListener(
    "ended",
    function (e) {
      if (!e.target.classList.contains("ctm_review-modal-video")) return;
      if (!modalSwiper || modalSwiper.isEnd) return;
      modalSwiper.slideNext();
      setTimeout(updateNavBtns, 100);
    },
    true
  );

  document.addEventListener(
    "timeupdate",
    function (e) {
      if (!e.target.classList.contains("ctm_review-modal-video")) return;
      const fill = e.target.closest(".ctm_modal_slide_inner")?.querySelector(".ctm_progress_fill");
      if (!fill || !e.target.duration) return;
      fill.style.width = (e.target.currentTime / e.target.duration) * 100 + "%";
    },
    true
  );

  document.addEventListener("click", function (e) {
    const slide = e.target.closest(".video_review_slider .review_video_main");
    if (!slide) return;
    const allSlides = Array.from(document.querySelectorAll(".video_review_slider .swiper-slide .review_video_main"));
    const index = allSlides.indexOf(slide);
    openReviewModal(index >= 0 ? index : 0);
  });

  if (ReviewCloseBtn) ReviewCloseBtn.addEventListener("click", closeReviewModal);

  document.addEventListener("click", function (e) {
    if (e.target.closest(".ctm_close_inline")) closeReviewModal();
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ctm_playpause_btn");
    if (!btn) return;
    const vid = btn.closest(".swiper-slide").querySelector("video");
    if (vid.paused) {
      vid.play();
    } else {
      vid.pause();
    }
  });

  document.addEventListener(
    "play",
    function (e) {
      if (!e.target.classList.contains("ctm_review-modal-video")) return;
      const btn = e.target.closest(".swiper-slide")?.querySelector(".ctm_playpause_btn");
      if (!btn) return;
      btn.querySelector(".ctm_icon_play").style.display = "none";
      btn.querySelector(".ctm_icon_pause").style.display = "block";
    },
    true
  );

  document.addEventListener(
    "pause",
    function (e) {
      if (!e.target.classList.contains("ctm_review-modal-video")) return;
      const btn = e.target.closest(".swiper-slide")?.querySelector(".ctm_playpause_btn");
      if (!btn) return;
      btn.querySelector(".ctm_icon_play").style.display = "block";
      btn.querySelector(".ctm_icon_pause").style.display = "none";
    },
    true
  );

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".ctm_mute_btn");
    if (!btn) return;
    const vid = btn.closest(".swiper-slide").querySelector("video");
    vid.muted = !vid.muted;
    btn.querySelector(".ctm_icon_unmuted").style.display = vid.muted ? "none" : "block";
    btn.querySelector(".ctm_icon_muted").style.display = vid.muted ? "block" : "none";
  });

  if (reviewModal) {
    reviewModal.addEventListener("click", function (e) {
      if (!e.target.closest(".ctm_modal-content")) closeReviewModal();
    });
  }
});

// ─── Video Review Swiper (thumbnail strip) ───────────────────────────────────
var swiper = new Swiper(".video_review_slider", {
  slidesPerView: 4,
  spaceBetween: 12,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: { slidesPerView: 3 },
    575: { slidesPerView: 4 },
    1024: { slidesPerView: 4 },
  },
});